const isNil = (value) => value == null;
export default isNil;
